export default __webpack_public_path__ + "static/media/WIEDZA.63fb9890.png";